import SFetch from '@app/utils/sfetch'
import api from '@app/application/document/screens/move-modal/api/index'

function handleActionButtonClick(e) {
  e.preventDefault()

  const selectEntries = document.querySelectorAll(
    "[name='permanent_entries_select']"
  )
  const selectedEntries = [...selectEntries]
    .filter((entry) => entry.checked)
    .map((entry) => entry.value)

  const action = e.target
  const actionType = action.dataset.actionType

  document.querySelector('[name="selected_entries"]').value = selectedEntries

  if (actionType === 'batch-destroy') {
    window.sfConfirm({
      question: I18n.t('js.permanent_document.destroy.confirm', {
        count: selectedEntries.length,
      }),
      onConfirm: () => {
        return SFetch.json(action.dataset.path, {
          method: 'POST',
          body: { selectedEntries: selectedEntries.join(',') },
        }).then((data) => {
          window.Turbolinks.visit(data.redirectTo)
        })
      },
    })
  } else if (actionType === 'batch-move') {
    const url = `${action.dataset.path}?selected_entries=${selectedEntries.join(
      ','
    )}`
    api.navigateTo(url).then((response) => {
      window.modalCitizen.openModal('move-document-modal', response)
    })
  }
}

onDomLoad(() => {
  if (!document.querySelector('[data-behaviour="documents-index"]')) return null

  handleDropdownButton()

  const batchActions = document.querySelectorAll(
    "[data-behaviour~='documents-batch-action']"
  )
  const selectEntries = document.querySelectorAll(
    "[name='permanent_entries_select']"
  )
  const selectAllButton = document.querySelector(
    "[data-behaviour~='documents-select-all']"
  )

  batchActions.forEach((action) => {
    // We're removing the listener and re-adding because onDomLoad can
    // trigger multiple times when uploading documents.
    action.removeEventListener('click', handleActionButtonClick)
    action.addEventListener('click', handleActionButtonClick)
  })

  if (selectAllButton) {
    selectAllButton.addEventListener('change', (event) => {
      selectEntries.forEach((el) => (el.checked = event.target.checked))
      handleDropdownButton()
      handleDownloadButton()
    })
  }

  selectEntries.forEach((el) =>
    el.addEventListener('change', () => {
      handleDropdownButton()
      handleDownloadButton()
    })
  )
})

const handleDropdownButton = function () {
  const dropdown = document.querySelector(
    '[data-behaviour="documents-actions-dropdown"]'
  )
  const dropdownForm = document.querySelector(
    '[data-behaviour="documents-actions-dropdown"] .sf-form-select'
  )

  const availableActions = document.querySelectorAll(
    "[data-behaviour~='documents-action']"
  ).length
  const availableBatchActions = document.querySelectorAll(
    "[data-behaviour~='documents-batch-action'], [data-action-type~='batch-download']"
  ).length

  const selectedEntries = document.querySelectorAll(
    '[name="permanent_entries_select"]:checked'
  ).length

  if (
    showActionDropdown(selectedEntries, availableActions, availableBatchActions)
  ) {
    dropdown.classList.remove('sf-hidden')
  } else {
    dropdown.classList.add('sf-hidden')
  }

  if (selectedEntries > 0) {
    dropdownForm.classList.add('sf-bg-primary', 'sf-c-white')
    dropdown.classList.add('sf-c-white')
  } else {
    dropdownForm.classList.remove('sf-bg-primary', 'sf-c-white')
    dropdown.classList.remove('sf-c-white')
  }
}

const handleDownloadButton = () => {
  const downloadButton = document.querySelector(
    '[data-action-type="batch-download"]'
  )
  if (!downloadButton) return null

  const selectedEntries = [
    ...document.querySelectorAll('[name="permanent_entries_select"]:checked'),
  ].map((entry) => entry.value)

  const url = Silverfin.Routes.batch_download_permanent_entries_path({
    firm_id: Silverfin.currentFirmId,
    company_id: Silverfin.currentCompanyId,
    selected_entries: selectedEntries.join(','),
    _options: true,
  })

  downloadButton.href = url
}

const showActionDropdown = (
  selectedEntries,
  availableActions,
  availableBatchActions
) => {
  if (selectedEntries === 0) {
    return availableActions > 0
  } else {
    return availableBatchActions > 0
  }
}
